module.exports = __webpack_public_path__ + "files/87e92f01ff95303ccabd0f60ad759314.png";